export const bulk_import_api = {
  get_configurations: "host/bulk_import/get/configurations",
  start_bulk_imports: "host/bulk_import/start/import",
  get_single_row_import: "host/bulk_import/view/import/data",
  bulk_import_list: "host/bulk_import/view/import/list",
  update_report_seen: "host/bulk_import/update/report/seen",
};
